import { Create } from "react-admin";
import { useAdmin } from "../../hooks/admin";
import { SellerForm } from "./_form";

export const SellerCreate = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("seller.create")) return null;

  return (
    <Create redirect="show">
      <SellerForm />
    </Create>
  );
};
